import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-643b82f6")

_pushScopeId("data-v-643b82f6")
const _hoisted_1 = {
  key: 0,
  class: "loader-container"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("dig-ui-loader", null, null, -1)
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "ctrl-buttons" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "center title-1" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "center title-1" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_project_display = _resolveComponent("project-display")
  const _component_project_form = _resolveComponent("project-form")
  const _component_base_card = _resolveComponent("base-card")

  return (_openBlock(), _createBlock(_component_base_card, { class: "main-card" }, {
    default: _withId(() => [
      ($setup.loading && !$setup.storeProject.getters[$setup.StoreGettersProject.PROJECT])
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _hoisted_2
          ]))
        : _createCommentVNode("", true),
      (!$setup.loading || $setup.storeProject.getters[$setup.StoreGettersProject.PROJECT])
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            (!$setup.storeProject.getters[$setup.StoreGettersProject.PROJECT])
              ? (_openBlock(), _createBlock("div", _hoisted_4, _toDisplayString($setup.t('noDataProject')), 1))
              : _createCommentVNode("", true),
            ($setup.storeProject.getters[$setup.StoreGettersProject.PROJECT])
              ? (_openBlock(), _createBlock("div", _hoisted_5, [
                  _createVNode("div", _hoisted_6, [
                    (!$setup.editing)
                      ? (_openBlock(), _createBlock("dig-ui-edit-button", {
                          key: 0,
                          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.toggleEditing())),
                          class: "icon-button"
                        }))
                      : _createCommentVNode("", true),
                    ($setup.editing)
                      ? (_openBlock(), _createBlock("dig-ui-close-button", {
                          key: 1,
                          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.toggleEditing())),
                          class: "icon-button"
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  (!$setup.editing)
                    ? (_openBlock(), _createBlock("div", _hoisted_7, [
                        _createVNode("dig-ui-title", _hoisted_8, _toDisplayString($setup.t('myProject')), 1),
                        _createVNode(_component_project_display, {
                          project: $setup.storeProject.getters[$setup.StoreGettersProject.PROJECT]
                        }, null, 8, ["project"])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.editing)
                    ? (_openBlock(), _createBlock("div", _hoisted_9, [
                        _createVNode("dig-ui-title", _hoisted_10, _toDisplayString($setup.t('editProject')), 1),
                        _createVNode(_component_project_form, {
                          project: $setup.storeProject.getters[$setup.StoreGettersProject.PROJECT],
                          loading: $setup.loadingForm,
                          onValidate: _cache[3] || (_cache[3] = ($event: any) => ($setup.updateProject($event))),
                          onCancel: _cache[4] || (_cache[4] = ($event: any) => ($setup.toggleEditing()))
                        }, null, 8, ["project", "loading"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})